import React, { useState, useContext, useEffect } from 'react';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { makeStyles } from '@material-ui/core/styles';
import { Button, AppBar, Toolbar, IconButton, Typography, Backdrop, CircularProgress, Fab, Grid } from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import '../../../css/common.css';
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import { GlobalTheme } from '../../../layouts/theme';
import { Theme } from '../../contexts/themeContext.js';
import { Context } from "../../contexts/siteContext.js";
import { HttpService } from "../../../apiAuthorization/httpService";
import Card from "../../card/card.js";
import CardBody from "../../card/cardBody.js";
import GridItem from "../../grid/gridItem.js";
import GridContainer from "../../grid/gridContainer.js";
import SmallMenu from '../../header/smallMenu';
import StatusIcon from '../../common/statusIcon';

const useStyles = makeStyles(styles);

export default function AddUnitLocation(props) {
    const classes = useStyles();
    const unitId = props.model.length === 0 ? 0 : props.model.Id;
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const [backDrop, setBackDrop] = useState(false);
    const [pageIndex, setPageIndex] = useState(1);
    const [locationLength, setlocationLength] = useState(0);
    const [locationName, setlocationName] = useState([]);
    const [locations, setLocations] = useState([]);
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [modified, setModified] = useState(false);
    const currentTheme = theme ? (GlobalTheme[theme]) : (GlobalTheme[localStorage.getItem("theme")]);

    const rowStyle = (rowIndex) => {
        return rowIndex % 2 === 0 ? 'list-item' : 'list-alternate-item';
    };

    const addUnitLocation = (goBack) => {
        if (backDrop) {
            return;
        }
        else if (selectedLocations.length > 0) {
            setBackDrop(true);
            HttpService.post('/Unit/SaveUnitLocations', {
                UnitId: unitId,
                LocationName: selectedLocations.toString()
            })
                .then(() => {
                    props.refreshGrid();
                    props.parentCallback();
                },
                    (error) => {
                        console.log(error);
                    });
        }
        else if (goBack) {
            props.parentCallback();
        }
    };

    const showMore = (e) => {
        let currentPageIndex = pageIndex + 1;
        setPageIndex(currentPageIndex);
        getLocations(currentPageIndex);
    };

    const setSelectedLocationData = (e, selectedLocationId, rowIndex) => {
        if (selectedLocations.indexOf(selectedLocationId) === -1) {
            selectedLocations.push(selectedLocationId);
            e.target.className = "list-item-selected";
        } else {
            selectedLocations.pop(selectedLocationId);
            e.target.className = (rowIndex % 2 === 0 ? 'list-item' : 'list-alternate-item');
        }
        setSelectedLocations(selectedLocations);
        setModified(true);
    };

    const getLocations = (currentPageIndex) => {
        setBackDrop(true);
        HttpService.post('/Unit/GetGeoLocationBranch', {
            GeoLocationBranchName: locationName,
            Site: defaultSite.id,
            GeoLocationAncestorId: defaultSite.id,
            PageIndex: currentPageIndex
        })
            .then((result) => {
                if (result.data) {
                    setLocations(result.data);
                    setlocationLength(result.data.length);
                } else {
                    console.log("error: location is null")
                }
                setBackDrop(false);

                if (result.data) {
                    if (result.data.length < currentPageIndex * 50 - 1)
                        setlocationLength(0);
                    else
                        setlocationLength(result.data.length);
                }
                else
                    setlocationLength(0);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    useEffect(() => {
        if (locationName.length > 0) {
            getLocations(pageIndex);
        }
    }, [locationName]); // eslint-disable-line

    let comp;
    if (locationLength > 0) {
        comp = <li onClick={e => showMore(e)} className="list-group-item active" style={{ cursor: 'pointer' }}>Show More...</li>;
    }

    return (<>
        <GridContainer style={{ justifyContent: 'center' }}>
            <Backdrop className={classes.backdrop} id="locationAddBackdrop" open={backDrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={() => addUnitLocation(true)} aria-label="back">
                        <KeyboardBackspaceIcon />
                    </IconButton>
                    <Grid container direction="row" alignItems="center">
                        <Grid item>
                            <Typography variant="h6" className={classes.title}>Add Locations</Typography>
                        </Grid>
                        <Grid item>
                            <StatusIcon />
                        </Grid>
                    </Grid>
                    <Grid container justify="flex-end">
                        <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="close" onClick={props.parentCallback}>
                            <CloseIcon />
                        </Fab>
                        <SmallMenu modified={modified} saveCallback={() => addUnitLocation(false)} />
                    </Grid>
                </Toolbar>
            </AppBar>
            <GridItem xs={8} sm={8} md={8}>
                <Card style={{ backgroundColor: currentTheme.background }}>
                    <CardBody style={{ color: currentTheme.text, marginTop: "50px", display: 'flex', justifyContent: 'center' }}>
                        <ValidatorForm className={classes.root} autoComplete="off" onSubmit={() => addUnitLocation(false)} style={{ width: "100%", display: "block" }}>
                             <TextValidator
                                label="Location"
                                placeholder="Type Location"
                                variant="outlined"
                                style={{ width: "100%" }}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                onChange={e => setlocationName(e.target.value)}
                            />
                            <br />
                            <div className="location area-location" style={{ width: "100%", maxHeight: "300px", overflowY: "scroll", padding: "0px !important" }}>
                                <ul className="list-group">
                                    {locations.map((location, index) => (
                                        <li key={index} className={rowStyle(index)} onClick={e => setSelectedLocationData(e, location.GeoLocationId, index)}>
                                            {location.GeoLocationBranchName}
                                        </li>
                                    ))}
                                    {comp}
                                </ul>
                            </div>
                            <br />
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                style={{ background: currentTheme.secondary, width: "100px", float: "right" }}
                                startIcon={<SaveIcon />}
                                type="submit"
                            >
                                Save
                            </Button>
                        </ValidatorForm>
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    </>
    );
}
